function findVisibleSlide() {
    let slideIndex = Q3.SlideManager.activeSlide;

    if (!Q3.SlideManager.getSlide(slideIndex).visible) {
        slideIndex = 0;

        const slideCount = Q3.SlideManager.slideCount;

        while (!Q3.SlideManager.getSlide(slideIndex).visible) {
            slideIndex++;

            if (slideIndex === slideCount) {
                slideIndex = 0;
                break;
            }
        }
    }

    return slideIndex;
}

export default findVisibleSlide;
export { findVisibleSlide };